<template>
    <div class="landing-container" :style="{paddingTop: topBarHeight + 'px'}">
        <div v-if="isPreparing && !isUser" class="preparing-page-container p-4">
            <div class="preparing-page-logo">
                <img v-if="context.logoContentUnit"  :src="context.storageEndpoint + context.logoContentUnit.file_name"/>
            </div>
            <div class="mt-2">
                <p>{{ $t('message.landing_page_is_preparing') }}</p>
            </div>
        </div>
        <div v-else-if="!hasInitedCustomer"></div>
        <div v-else>
            <!-- Top Bar -->
            <div class="top-bar-container px-4 py-2" ref="topBarContainer">
                <top-bar-customer-section :context="context"
                    :provider="provider" scrollElementClass="landing-container" />

            </div>
            <block-hero :provider="provider" :context="context"></block-hero>
            <div class="landing-block" v-for="block in blocks" :key="block.id">
                <block-text-and-image v-if="isTextAndImage(block.information_block)" :context="context"
                    :providerId="context.providerId" :key="block.id || (new Date()).getTime()" :block="block" />

                <block-portfolio v-if="isPortfolio(block.information_block)" ref="portfolio" :context="context"
                    :providerId="context.providerId" :key="block.id || (new Date()).getTime()" :block="block" />

                <block-address v-if="isAddress(block.information_block)" :context="context" :providerId="context.providerId"
                    :key="block.id || (new Date()).getTime()" :block="block" />

                <block-user-review v-if="isUserReview(block.information_block)" :context="context"
                    :providerId="context.providerId" :key="block.id || (new Date()).getTime()" :block="block" />

                <block-provider-recommendation v-if="isProviderRecommendation(block.information_block)" :context="context"
                    :providerId="context.providerId" :key="block.id || (new Date()).getTime()" :block="block" />

                <block-text v-if="isText(block.information_block)" :context="context" :providerId="context.providerId"
                    :key="block.id || (new Date()).getTime()" :block="block" />

                <block-services v-if="isServices(block.information_block)" :context="context"
                    :providerId="context.providerId" :key="block.id || (new Date()).getTime()" :block="block" />

                <block-members v-if="isMembers(block.information_block)" :context="context" :providerId="context.providerId"
                    :key="block.id || (new Date()).getTime()" :block="block" />

                <block-ig v-if="isIG(block.information_block)" :context="context" :providerId="context.providerId"
                    :key="block.id || (new Date()).getTime()" :block="block" />

                <block-bookable v-if="isBookables(block.information_block)" :context="context"
                    :providerId="context.providerId" :key="block.id || (new Date()).getTime()" :block="block" />

                <block-youtube v-if="isYoutube(block.information_block)" :context="context"
                    :providerId="context.providerId" :key="block.id || (new Date()).getTime()" :block="block" />
            </div>
        </div>
        <div v-if="isPreparing && isAdminOfProvider" class="preparation-hint-container">
            <div>{{ $t('message.preparation_hint') }}</div>
        </div>
        <Interstitial v-if="activeInterstitials.length" :context="context" :interstitials="activeInterstitials" />
    </div>
</template>

<script>
    import awareBlockType from '../../mixins/aware-block-type';
    import RootStore from '../../stores/root';
    import { mapActions, mapGetters } from 'vuex';
    import TopBarCustomerSection from '../common/TopBarCustomerSection.vue';
    import 'moment-timezone';
    import Interstitial from '../interstitial/Interstitial.vue';

    export default {
        store: RootStore,
        props: {
            blocks: {
                required: true,
                type: Array
            },
            context: {
                required: true,
                type: Object
            },
            provider: {
                required: true,
                type: Object
            }
        },
        mixins: [awareBlockType],
        components: { TopBarCustomerSection, Interstitial },
        data() {
            var preopenedPortfolioAlbum = null;
            let albumMatch = document.location.href.match(/^.*\/i\/([0-9]+)\/a\/([a-z0-9\-\.]+)(\/p\/){0,1}([0-9a-z]+){0,1}/)
            if (albumMatch) {
                preopenedPortfolioAlbum = {
                    portfolioId: albumMatch[1],
                    albumId: albumMatch[2],
                    contentUnitId: albumMatch[4]
                }
            }
            return {
                preopenedPortfolioAlbum,
                topBarHeight: 0
            }
        },
        async mounted() {
            await this.initCustomer();
            this.getCurrencies();
            this.openAlbumIfNeeded();
            this.getInterstitials();

            this.topBarHeight = this.$refs['topBarContainer'].clientHeight;
            window.addEventListener('resize', () => {
                this.topBarHeight = this.$refs['topBarContainer'].clientHeight;
            })
        },
        computed: {
            ...mapGetters({
                hasInitedCustomer: 'app/hasInitedCustomer',
                customer: 'app/customer',
                interstitials: 'interstitials/interstitials'
            }),
            activeInterstitials() {
                return this.interstitials.filter(i => i.is_enabled).sort((a, b) => a.order - b.order);
            },
            isPreparing() {
                return this.provider.is_preparing;
            },
            isAdminOfProvider() {
                return this.context.isProviderAdmin;
            },
            isUser() {
                return !!this.context.currentUserId;
            }
        },
        methods: {
            ...mapActions({
                initCustomer: 'app/initCustomer',
                getLoggedInCustomer: 'app/getLoggedInCustomer',
                getInterstitials: 'interstitials/getInterstitials',
                getCurrencies: 'currencies/getCurrencies',
            }),
            openAlbumIfNeeded() {
                if (this.preopenedPortfolioAlbum) {
                    // clear history stack and portfolio block will set correct history item
                    window.history.replaceState({}, null, '/');

                    this.$nextTick(() => {
                        const $portfolioEl = this.$refs['portfolio'].find((item) => {
                            return item.$props.block.id == this.preopenedPortfolioAlbum.portfolioId
                        });
                        const album = $portfolioEl.albums.find(album => album.meta.id == this.preopenedPortfolioAlbum.albumId);
                        $portfolioEl.openAlbum(
                            this.preopenedPortfolioAlbum.albumId,
                            this.preopenedPortfolioAlbum.contentUnitId,
                            album
                        );
                    });
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.logo img {
    @media screen and (max-width: 425px) {
        margin: 0;
    }
}

.preparing-page-container {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    
    p {
        text-align: center;
        margin: 0;
        font-size: 20px;
        color: #4A90E2;
    }
}

.preparing-page-logo {
    max-width: 72px;
    
    img {
        width: 100%;
    }
}

.preparation-hint-container {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    background-color: #fff;
    color: #6c757d;
    z-index: 2147483647;
    padding: 16px;
    display: flex;
    align-content: center;
    justify-content: center;
    box-shadow: 0px 2px 6px #eee;
}

</style>
